import http from "./http"
import { League, TeamHubLeagueResponse } from "../models/league"
import HelperService from "../services/helper"
import { Pagination, QueryParams } from "../models/misc"
import { CreateStatsDTO, Stats } from "../models/stats"

class LeagueService {
  private readonly baseUrl = "/league"

  async listLeagues(filters?: QueryParams) {
    const queryString = HelperService.buildSearchQueryString(filters)
    const { data } = await http.get<Pagination<League>>(`${this.baseUrl}${queryString}`)
    return data
  }

  async getTeamHubLeague(leagueId: string) {
    const { data } = await http.get<TeamHubLeagueResponse>(`${this.baseUrl}/${leagueId}/hub`)
    return data
  }

  async getLeagueById(id: string): Promise<League> {
    const { data } = await http.get<League>(`${this.baseUrl}/${id}`)
    return data
  }

  // League Stats
  async createStats(leagueId: string, dto: CreateStatsDTO) {
    const { data } = await http.post<Stats>(`${this.baseUrl}/${leagueId}/stats`, dto)
    return data
  }
}

export default new LeagueService()
